import React from "react";
import { Check, X, Lock } from "lucide-react";
import Reveal from "./Reveal";

const DO = [
    "Читаємо дані вашої реклами",
    "Аналізуємо ключові слова і витрати",
    "Складаємо конкретний план змін",
    "Пояснюємо кожне рішення простою мовою",
];

const DONT = [
    "Самостійно витрачати ваш бюджет",
    "Вносити зміни без вашого підтвердження",
    "Зупиняти або запускати кампанії без дозволу",
    "Мати доступ до платіжних даних Google",
];

export const BudgetProtection = () => {
    return (
        <section className="section bg-surface/30 border-y border-border" data-testid="budget-protection">
            <div className="container-mx">
                <Reveal>
                    <div className="text-center max-w-[720px] mx-auto">
                        <div className="tag tag-primary mx-auto inline-flex">// БЕЗПЕКА БЮДЖЕТУ</div>
                        <h2 className="mt-6 font-display font-extrabold text-text-primary" style={{ fontSize: "clamp(32px, 5vw, 52px)", letterSpacing: "-0.025em" }}>
                            Ми бачимо вашу рекламу. <br className="hidden md:block" />
                            <span className="text-secondary-c">Змінюєте тільки ви.</span>
                        </h2>
                        <p className="mt-6 text-lg text-secondary-c leading-relaxed">
                            У нас є доступ до вашого акаунту для аналізу — але ми не можемо
                            витратити жодної копійки без вашого підтвердження.
                        </p>
                    </div>
                </Reveal>

                <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <Reveal>
                        <div
                            data-testid="do-card"
                            className="glass rounded-2xl p-7 h-full"
                            style={{ borderLeft: "2px solid #2DD4BF", borderColor: "rgba(45,212,191,0.25)" }}
                        >
                            <h3 className="font-display font-bold text-xl text-text-primary">Що ми робимо</h3>
                            <ul className="mt-5 space-y-3">
                                {DO.map((d, i) => (
                                    <li key={i} className="flex gap-3 items-start">
                                        <Check size={18} className="text-success-c mt-0.5 shrink-0" />
                                        <span className="text-sm text-text-primary/90">{d}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>

                    <Reveal delay={0.1}>
                        <div
                            data-testid="dont-card"
                            className="glass rounded-2xl p-7 h-full"
                            style={{ borderLeft: "2px solid #F87171", borderColor: "rgba(248,113,113,0.2)" }}
                        >
                            <h3 className="font-display font-bold text-xl text-text-primary">Чого ми ніколи не робимо</h3>
                            <ul className="mt-5 space-y-3">
                                {DONT.map((d, i) => (
                                    <li key={i} className="flex gap-3 items-start">
                                        <X size={18} className="text-error-c mt-0.5 shrink-0" />
                                        <span className="text-sm text-text-primary/90">{d}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>
                </div>

                <Reveal delay={0.15}>
                    <div className="mt-8 rounded-xl p-6 flex items-start gap-4" style={{ background: "var(--surface-hover)" }}>
                        <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0" style={{ background: "rgba(109,94,248,0.15)" }}>
                            <Lock size={18} className="text-primary-c" />
                        </div>
                        <div>
                            <h4 className="font-display font-semibold text-lg text-text-primary">
                                Зараз AutoAds — ваш аналітик, не пілот.
                            </h4>
                            <p className="mt-2 text-sm text-secondary-c leading-relaxed">
                                Ми готуємо детальний план дій — ви вирішуєте що впроваджувати.
                                Пізніше можна увімкнути автоматичні зміни одним перемикачем.
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default BudgetProtection;
